import { RootModel } from '@types';
import { entities } from './entities';
import { model } from './model';

export const models: RootModel = {
  ...model,
  ...entities,
};
